module.exports = __webpack_public_path__ + "img/demo3.aa4ba573.png";